<template>
  <div>
    <b-overlay
      :show="isLoadingForms"
      rounded="sm"
    >
      <div>
        <h2 class="mb-2">{{$t('dashboardNewEmployee')}}</h2>
        <b-row align-h="center">
          <b-col cols="3">
            <h5>
              <b>{{$t('policies.title') +' ('+policyFormsTasksLength+')'}}​</b>
            </h5>
            <b-link to="/employee-tasks/policy">
              <b-card
                bg-variant="default"
                class="mb-2 click-cursor card-wrapper"
              >
                <b-card-text class="my-3">
                  <font-awesome-icon
                    icon="file-signature"
                    size="6x"
                    style="color: #3ddc97"
                  />
                </b-card-text>
                <b-card-text class="text-dark"><b>{{$t('policies.cardText')}}</b></b-card-text>
                <b-card-text>
                  <b-button
                    to="/employee-tasks/policy"
                    variant="outline-primary"
                  >{{$t('btnAccessHereText')}}</b-button>
                </b-card-text>
              </b-card>
            </b-link>
          </b-col>
          <!-- class="disabledDiv" -->
          <b-col cols="3">
            <h5>
              <b>{{$t('training.title') + ' ('+ trainingFormsTasksLength + ')'}}​</b>
            </h5>
            <b-link to="/employee-tasks/trainings">
              <b-card
                bg-variant="default"
                class="mb-2 click-cursor card-wrapper"
              >
                <b-card-text class="my-3">
                  <font-awesome-icon
                    icon="graduation-cap"
                    size="6x"
                    style="color: #3ddc97"
                  />
                </b-card-text>
                <b-card-text class="text-dark"><b>{{$t('training.titleEmployee')}}</b></b-card-text>
                <b-card-text>
                  <b-button
                    to="dashboard"
                    variant="outline-primary"
                    hidden
                  >
                    {{$t('comingSoon')}}
                  </b-button>
                  <b-button
                    to="/employee-tasks/trainings"
                    variant="outline-primary"
                  >{{$t('btnAccessHereText')}}</b-button>
                </b-card-text>
              </b-card>
            </b-link>
          </b-col>
          <b-col cols="3">
            <h5>
              <b>{{$t('certifications.title')+ ' ('+ certificationFormsTasksLength + ')'}}​</b>
            </h5>
            <b-link to="/employee-tasks/certification">
              <b-card
                bg-variant="default"
                class="mb-2 click-cursor card-wrapper"
              >
                <b-card-text class="my-3">
                  <font-awesome-icon
                    icon="certificate"
                    size="6x"
                    style="color: #3ddc97"
                  />
                </b-card-text>
                <b-card-text class="text-dark">
                  <b>{{$t('certifications.titleEmployee')}}</b>
                </b-card-text>
                <b-card-text>
                  <b-button
                    variant="outline-primary"
                    to="/employee-tasks/certification"
                  >{{$t('btnAccessHereText')}}</b-button>
                </b-card-text>
              </b-card>
            </b-link>
          </b-col>
        </b-row>
        <!-- class="disabledDiv" -->
        <b-row
          style="margin-top: 25px"
          align-h="center"
        >
          <b-col cols="3">
            <h5>
              <b>{{$t('healthAndSafety.title')+ ' ('+ healthAndSafetyFormsTasksLength + ')'}}​</b>
            </h5>
            <b-link>
              <b-card
                bg-variant="default"
                class="mb-2 click-cursor card-wrapper"
              >
                <b-card-text class="my-3">
                  <font-awesome-icon
                    icon="file-signature"
                    size="6x"
                    style="color: #3ddc97"
                  />
                </b-card-text>
                <b-card-text class="text-dark">
                  <b>{{$t("healthAndSafety.titleEmployee")}}​</b>
                </b-card-text>
                <b-card-text>
                  <b-button
                    to="/employee-tasks/health_and_safety_policy"
                    variant="outline-primary"
                    @click="showAddApprovalModal"
                  >
                    {{$t("healthAndSafety.policyBtn")}}​
                  </b-button>
                  <b-button
                    class="ml-2"
                    variant="outline-primary"
                    to="/employee-tasks/health_and_safety_training"
                  >{{$t("healthAndSafety.trainingBtn")}}</b-button>
                </b-card-text>
              </b-card>
            </b-link>
          </b-col>
          <b-col cols="3">
            <h5><b>{{$t("approvals.myApprovals")}}</b>​</h5>
            <b-link to="employee-approvals">
              <b-card
                bg-variant="default"
                class="mb-2 click-cursor card-wrapper"
              >
                <b-card-text class="my-3">
                  <font-awesome-icon
                    icon="check-circle"
                    size="6x"
                    style="color: #3ddc97"
                  />
                </b-card-text>
                <b-card-text class="text-dark">
                  <b>{{$t("approvals.fillApproval​")}}​</b>
                </b-card-text>
                <b-card-text>
                  <b-button
                    to="dashboard"
                    variant="outline-primary"
                    hidden
                  >
                    {{$t('comingSoon')}}
                  </b-button>
                  <b-button
                    to="employee-approvals-user-form"
                    variant="outline-primary"
                    @click="showAddApprovalModal"
                  >
                    {{$t("approvals.newRequest")}}​
                  </b-button>
                  <b-button
                    class="ml-2"
                    variant="outline-primary"
                    to="employee-approvals"
                  >{{$t("approvals.myApprovals")}}</b-button>
                </b-card-text>
              </b-card>
            </b-link>
          </b-col>
          <b-col cols="3">
            <h5><b>{{$t("complaints.complaintsHotline")}}</b>​</h5>
            <b-link to="employee-complaints">
              <b-card
                bg-variant="default"
                class="mb-2 click-cursor card-wrapper"
              >
                <b-card-text class="my-3">
                  <font-awesome-icon
                    icon="comments"
                    size="6x"
                    style="color: #3ddc97"
                  />
                </b-card-text>
                <b-card-text class="text-dark">
                  <b>{{$t("complaints.fileComplaint")}}</b>
                </b-card-text>
                <b-card-text>
                  <b-button
                    to="dashboard"
                    variant="outline-primary"
                    hidden
                  >
                    {{$t('comingSoon')}}
                  </b-button>
                  <b-button
                    @click="onDirectLink"
                    to="add-complaint"
                    variant="outline-primary"
                  >{{$t("complaints.newComplaint")}}</b-button>
                  <b-button
                    class="ml-2"
                    variant="outline-primary"
                    to="employee-complaints"
                  >{{$t("complaints.myComplaints")}}</b-button>
                </b-card-text>
              </b-card>
            </b-link>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
    <!-- <AddApprovalModal /> -->
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../../utils/HTTP";
import "moment/locale/es";
import { CurrencyDirective } from "vue-currency-input";
import { EventBus } from "@/event-bus.js";
import { Helper } from "../../../helpers";
// import AddApprovalModal from "../../../components/newEmployeeComponents/addApprovalModal/addApprovalModal.vue";
export default {
  name: "NewDashboardTheme",
  mixins: [validationMixin],
  directives: {
    currency: CurrencyDirective,
  },
  components: {
    // AddApprovalModal,
  },
  data () {
    return {
      isLoadingForms: false,
      showAddApproverModal: false,
      form: {
        approvalType: null,
        currency: "USD",
        amount: null,
        description: null,
      },
      approvalTypesOptions: [],
      currenciesOptions: [],
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      policyFormsTasksLength: 0,
      trainingFormsTasksLength: 0,
      certificationFormsTasksLength: 0,
      healthAndSafetyFormsTasksLength: 0,
    };
  },
  validations: {
    form: {
      approvalType: { required },
      currency: { required },
      amount: { required },
    },
  },
  mounted () {
    // this.getApprovalTypesList();
    this.getEmployeeTasks();
  },

  methods: {
    onDirectLink () {
      EventBus.$emit( "onDirectLink", "" );
    },
    showAddApprovalModal () {
      EventBus.$emit( "onDirectAddApprovalLink", "" );
      // EventBus.$emit( "onAddApprovalModal", "" );
    },
    async getEmployeeTasks () {
      this.$store.state.policyFormsTasks = [];
      this.$store.state.trainingFormsTasks = [];
      this.$store.state.certificationFormsTasks = [];
      this.policyFormsTasksLength = 0;
      this.trainingFormsTasksLength = 0;
      this.certificationFormsTasksLength = 0;
      this.healthAndSafetyFormsTasksLength = 0;
      let employeeId = localStorage.getItem( "employeeId" );
      this.isLoadingForms = true;
      let response = await HTTP( "get",
        "api/v1/onboarding/employee/new/tasks/" + employeeId, null
      );
      try {
        if ( response && response.data ) {
          this.$store.state.policyFormsTasks = response.data.policy;
          this.$store.state.trainingFormsTasks = response.data.trainings;
          this.$store.state.certificationFormsTasks = response.data.certification;
          
          let filterNotCompletedPolicy = response.data.policy ? response.data.policy.filter(item => {
            return item.task_status != 4
          }):[];
          this.policyFormsTasksLength = filterNotCompletedPolicy ? filterNotCompletedPolicy.length : 0;
          
          let filterNotCompletedTrainings = response.data.trainings ? response.data.trainings.filter(item => {
            return item.task_status != 4
          }):[];
          this.trainingFormsTasksLength = filterNotCompletedTrainings ? filterNotCompletedTrainings.length : 0;

          let filterNotCompletedCertification = response.data.certification ? response.data.certification.filter(item => {
            return item.task_status != 4
          }):[];
          this.certificationFormsTasksLength = filterNotCompletedCertification ? filterNotCompletedCertification.length : 0;

          let filterNotCompletedHealth_and_safety_policy = response.data.health_and_safety_policy ? response.data.health_and_safety_policy.filter(item => {
            return item.task_status != 4
          }):[];
          let healthAndSafetyPolicyTasksLength = filterNotCompletedHealth_and_safety_policy ? filterNotCompletedHealth_and_safety_policy.length : 0;

          let filterNotCompletedHealth_and_safety_training = response.data.health_and_safety_training ? response.data.health_and_safety_training.filter(item => {
            return item.task_status != 4
          }):[];
          let healthAndSafetyTrainingTasksLength = filterNotCompletedHealth_and_safety_training ? filterNotCompletedHealth_and_safety_training.length : 0;
          this.healthAndSafetyFormsTasksLength = healthAndSafetyPolicyTasksLength + healthAndSafetyTrainingTasksLength;
        }
        this.isLoadingForms = false;
      } catch ( err ) {
        this.isLoadingForms = false;
        return [err];
      }
    },
    resetForm () {
      this.form = {
        approvalType: null,
        currency: "USD",
        amount: null,
        description: null,
      };
      this.$v.$reset();
    },
    resetModal () {
      this.resetForm();
      this.showAddApproverModal = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else {
        this.saveApproval();
      }
    },
    makeToster ( tosterVarient, tosterMsg ) {
      this.resetModal();
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    async saveApproval () {
      let employeeId = localStorage.getItem( "employeeId" );
      let formData = {
        approval_type_id: this.form.approvalType
          ? this.form.approvalType.value
          : null,
        approval_type: this.form.approvalType
          ? this.form.approvalType.text
          : null,
        currency_id: 1,
        employee_id: employeeId,
        amount: this.form.amount,
        meta_data: {
          description: this.form.description,
        },
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", "api/v1/approvals/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if ( result.data.status != 1 ) {
          this.makeToster( "danger", result.data.message );
        } else if ( result.data.status == 1 ) {
          this.makeToster( "success", result.data.message );
        }
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async getApprovalTypesList () {
      this.approvalTypesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/approvals/type/list", null );
        this.approvalTypesOptions = result.data.approvalTypes;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.disabledDiv {
  pointer-events: none;
  opacity: 1;
}
</style>